export const accessCodePlaceHolderDataSet = { cy: 'access-code-place-holder' };
export const accessCodeContinueButtonDataSet = { cy: 'access-code-continue-button' };
export const errorMessageDataSet = { cy: 'error-message' };
